import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Banner from "../../../component/Banner";
import Bannerimg from "../../../images/igmaing/iGaming-banner.webp";
import image1 from "../../../images/igmaing/igmaing1.webp";
import image2 from "../../../images/igmaing/igmaing2.webp";
import image3 from "../../../images/igmaing/igmaing3.webp";
import image4 from "../../../images/igmaing/igmaing4.webp";
import image5 from "../../../images/igmaing/igmaing5.webp";
import image6 from "../../../images/igmaing/igmaing6.webp";

const IGaming = () => {
  const banner = {
    title: "iGaming",
    image: Bannerimg,
  };
  const card = [
    {
      image: image1,
      title: "Custom iGaming Software Development",
      description:
        "Our team specializes in developing high-quality, custom iGaming software solutions that are both scalable and flexible. From captivating slot games to comprehensive sports betting systems, we design and develop solutions that enhance user engagement and retention.",
    },
    {
      image: image2,
      title: "Platform Integration Services",
      description:
        "Seamlessly integrate a wide range of gaming content and third-party systems (payment gateways, game providers, KYC databases) with our platform integration services. We ensure smooth, secure, and efficient integration that enhances the overall user experience.",
    },
    {
      image: image3,
      title: "Mobile App Development",
      description:
        "With mobile gaming on the rise, having a mobile-first approach is crucial. Our mobile app development services focus on creating intuitive, fast-loading, and feature-rich mobile applications for both Android and iOS platforms, ensuring your users can play anywhere, anytime.",
    },
    {
      image: image4,
      title: "Compliance and Regulatory Advisory",
      description:
        "Stay compliant with the ever-changing regulatory landscape of the iGaming industry. Our experts provide advisory services on licensing requirements, data protection, and ensure your platform adheres to all legal and regulatory standards in your target markets.",
    },
    {
      image: image5,
      title: "Cybersecurity Solutions for iGaming",
      description:
        "Protect your platform and your users with our advanced cybersecurity solutions. From securing transactions to safeguarding user data and preventing fraud, our security measures are designed to build trust and ensure a safe gaming environment.",
    },
    {
      image: image6,
      title: "Cloud Solutions and Infrastructure",
      description:
        "Leverage the power of cloud computing for unmatched scalability, reliability, and performance. Our cloud solutions include hosting services, cloud storage, and bespoke infrastructure design to support the demanding nature of iGaming platforms.",
    },
    {
      image: image5,
      title: "Customer Support and CRM Systems",
      description:
        "Enhance your customer service with our custom CRM systems and support solutions. We help you implement effective communication channels, automate responses, and manage user interactions efficiently to improve customer satisfaction and loyalty.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          iGaming — Cylon Technologies – Big Data | Data Analytics | Digital
          Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content pb-5">
        <div className="container">
          <h2 className="heading2 text-center pb-4">iGaming IT Services</h2>
          <p>
            In the rapidly evolving world of iGaming, staying ahead of
            technological advancements and regulatory changes is not just an
            option—it's a necessity. Our comprehensive IT services are tailored
            specifically for the iGaming industry, ensuring your platform is
            robust, secure, and engaging for users across the globe. Whether
            you're looking to launch a new online casino, sports betting
            platform, or any other type of digital gaming operation, we have the
            expertise to bring your vision to life.
          </p>
          <p className="text-center">Our iGaming IT Services include:</p>
          <div className="col-md-10 mx-auto">
            <div className="row g-md-5 g-4">
              {card.map((item, index) => (
                <div className="col-md-6" key={index}>
                  <div className="img_card">
                    <img src={item.image} alt="images" />
                    <h2 className="heading2">{item.title}</h2>
                    <p>{item.description}</p>

                    {item.tagName && item.tagLink && (
                      <div className="btn_spacet">
                        <a
                          href={item.tagLink}
                          className="btn_small outline_blue"
                        >
                          {item.tagName}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <p className="text-center">
                At Cylon Technologies, we understand the unique challenges and
                opportunities within the iGaming industry. Our team of experts
                is dedicated to delivering innovative IT solutions that not only
                meet the current demands of the market but also anticipate
                future trends. Let us help you create an iGaming platform that
                stands out in the competitive digital landscape.
              </p>
              <p className="text-center">
                Contact us today to discuss how we can elevate your iGaming
                business to the next level.
              </p>
            </div>
            <div className="text-center pt-5 mt-5">
              <Link
                to="/connect"
                className="btn_custom blue_btn"
                href="Inquire"
              >
                Inquire
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IGaming;
